//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function dmyToISO(d) {
  if (!d) return "";
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(d).trim());
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
}
function isoToDMY(iso) {
  if (!iso) return "";
  const p = String(iso).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : "";
}

export default {
  name: "DateField",
  props: {
    value: { type: String, default: "" }, // DD/MM/YYYY
    label: { type: String, default: "" },
    color: { type: String, default: "primary" },
  },
  data() {
    return {
      menu: false,
      display: this.value || "",     // ข้อความในช่อง (DD/MM/YYYY)
      picker: dmyToISO(this.value),  // ค่า ISO ให้ปฏิทิน
    };
  },
  watch: {
    value(v) {
      this.display = v || "";
      this.picker = dmyToISO(v);
    },
    picker(iso) {
      // เลือกจากปฏิทิน -> จัดรูป DD/MM/YYYY + ส่งกลับ parent
      const dmy = isoToDMY(iso);
      this.display = dmy;
      this.$emit("input", dmy);
    },
  },
  methods: {
    onType(v) {
      this.display = v || "";
      this.$emit("input", this.display);
    },
    onClear() {
      this.display = "";
      this.picker = "";
      this.$emit("input", "");
    },
    // พิมพ์เอง -> parse/normalize ตอน blur หรือกด Enter
    normalize() {
      const iso = dmyToISO(this.display);
      if (iso) this.picker = iso; // watcher จะจัดรูป + emit ให้
    },
  },
};
